import { writeWebsiteSuggestion } from "~/lib/marketplace/hire-website-suggestion";
import { clearHireWizardProgress } from "~/lib/marketplace/hire-wizard-steps";
import { resolveHireBusinessDisplayName } from "~/lib/marketplace/hire-company-name";
import {
  normalizeMarketplaceWebsiteUrl,
  type WebsiteAgentSuggestion,
} from "~/lib/marketplace/website-suggestions";

export async function analyzeWebsiteForHire(
  rawUrl: string,
  options?: { skipOnboardingAlert?: boolean },
): Promise<WebsiteAgentSuggestion> {
  const normalized = normalizeMarketplaceWebsiteUrl(rawUrl);
  if (!normalized) {
    throw new Error("Enter a valid business website (e.g. yourbusiness.com).");
  }

  const response = await fetch("/api/marketplace/suggest-from-website", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      url: normalized,
      skipOnboardingAlert: options?.skipOnboardingAlert === true,
    }),
    signal: AbortSignal.timeout(45_000),
  });

  const data = (await response.json()) as WebsiteAgentSuggestion & { error?: string };
  if (!response.ok) {
    throw new Error(data.error ?? "Could not analyze that website.");
  }

  // Persist suggestion only — do NOT clear Trish transcript / onboarding state here.
  // Clearing wiped mid-flow progress and broke resume after Sign Up / email verify.
  writeWebsiteSuggestion(data);
  clearHireWizardProgress();
  return data;
}

export function buildHirePathWithWebsiteSuggestion(
  basePath: string,
  suggestion: WebsiteAgentSuggestion,
): string {
  const params = new URLSearchParams({
    website: suggestion.websiteUrl,
    company:
      resolveHireBusinessDisplayName(suggestion.businessName, suggestion.websiteUrl) ||
      suggestion.businessName,
  });
  return `${basePath}?${params.toString()}`;
}
